import Media from 'react-media';
import { price as priceUtils } from '@eti/utils';
import { Heading } from '@etg/wings';
import { mediaQueries, css } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import { ScreenReaderPrice } from '@eti/components';
import PayButton from '../../../pages/post-booking/ancillary-store/entry-page/components/PayButton';
import { CartRow, Price } from '../../cart/components/CartComponents';

const totalPriceStyles = css`
  font-size: 1rem;
`;

interface OrderTotalProps {
  totalPrice: number;
  isLoading: boolean;
}

const OrderTotal = ({ totalPrice, isLoading }: OrderTotalProps) => {
  const { t } = useTranslation();

  return (
    <>
      <CartRow>
        <Heading level={4}>{t('Cart.PriceSummary.Total.Label')}</Heading>
        <Price aria-hidden className={totalPriceStyles}>
          <strong>{priceUtils.formatPrice(totalPrice)}</strong>
        </Price>
        <ScreenReaderPrice price={priceUtils.formatPrice(totalPrice)} />
      </CartRow>
      <Media query={mediaQueries.large.up}>
        {(matches) => matches && <PayButton isLoading={isLoading} />}
      </Media>
    </>
  );
};

export default OrderTotal;
